// @flow

import type {ApplicationState} from '../../types'
import type {GbiprojectState} from '../types'

export function getError(appState: ApplicationState): ?string {
  return _getError(appState.gbiProject)
}

function _getError(state: GbiprojectState): ?string {
  return state.error
}

getError.internal = _getError
